<template>
  <pdf src="/files/AdminPanel.pdf" v-for="i in 52" :key="i" :page="i"></pdf>
</template>

<script>
import pdf from "vue3-pdf";
export default {
  components: {
    pdf,
  },
};
</script>

<style></style>
